import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layout Components
import ProtectedRoute from "./components/auth/protected-route/ProtectedRoute";
import Layout from "./components/common/Layout";
// import { useAuth } from "./hooks/useAuth";
// Pages
import ForgotPassword from "./pages/auth/forgot-password/ForgotPassword";
import Login from "./pages/auth/login/Login";
import Register from "./pages/auth/register/Register";
import Checkout from "./pages/booking/checkout/Checkout";
import Confirmation from "./pages/booking/confirmation/Confirmation";
import SeatSelection from "./pages/booking/seat-selection/SeatSelection";
import AdminDashboard from "./pages/dashboard/admin/AdminDashboard";
import FanDashboard from "./pages/dashboard/fan/FanDashboard";
import ManagerDashboard from "./pages/dashboard/manager/ManagerDashboard";
import OrganizerDashboard from "./pages/dashboard/organizer/OrganizerDashboard";
import EventDetails from "./pages/events/event-details/EventDetails";
import EventList from "./pages/events/event-list/EventList";
import GroundDetails from "./pages/grounds/ground-details/GroundDetails";
import GroundList from "./pages/grounds/ground-list/GroundList";
import Home from "./pages/home/Home";
import Profile from "./pages/profile/Profile";
import { store } from "./store";
import { ROUTES } from "./utils/constants";

// Styles
import "./styles/globals.css";

function AppContent() {
  // const { isAuthenticated, user } = useAuth();

  return (
    <Router>
      <Layout>
        <Routes>
          {/* Public Routes */}
          <Route path={ROUTES.HOME} element={<Home />} />
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={ROUTES.REGISTER} element={<Register />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTES.GROUNDS} element={<GroundList />} />
          <Route path={ROUTES.GROUND_DETAILS} element={<GroundDetails />} />
          <Route path={ROUTES.EVENTS} element={<EventList />} />
          <Route path={ROUTES.EVENT_DETAILS} element={<EventDetails />} />

          {/* Protected Routes */}
          <Route
            path={ROUTES.SEAT_SELECTION}
            element={
              <ProtectedRoute>
                <SeatSelection />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.CHECKOUT}
            element={
              <ProtectedRoute>
                <Checkout />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.CONFIRMATION}
            element={
              <ProtectedRoute>
                <Confirmation />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PROFILE}
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          {/* Role-based Dashboard Routes */}
          <Route
            path={ROUTES.DASHBOARD.FAN}
            element={
              <ProtectedRoute allowedRoles={["fan"]}>
                <FanDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.DASHBOARD.ORGANIZER}
            element={
              <ProtectedRoute allowedRoles={["organizer"]}>
                <OrganizerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.DASHBOARD.MANAGER}
            element={
              <ProtectedRoute allowedRoles={["manager"]}>
                <ManagerDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.DASHBOARD.ADMIN}
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Layout>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
